import { lazy } from 'react';
import { Route } from 'react-router-dom';
import BuyerProtectedRoute from '../modules/Public/Marketplace/components/BuyerProtectedRoute';
import BuyerAccountLayout from '../modules/Public/Marketplace/components/BuyerAccountLayout';

const MarketplaceHome = lazy(() => import('../modules/Public/Marketplace/MarketplaceHome'));
const MarketplaceSearch = lazy(() => import('../modules/Public/Marketplace/MarketplaceSearch'));
const MarketplacePropertyDetail = lazy(() => import('../modules/Public/Marketplace/MarketplacePropertyDetail'));
const BuyerRegister = lazy(() => import('../modules/Public/Marketplace/BuyerRegister'));
const BuyerLogin = lazy(() => import('../modules/Public/Marketplace/BuyerLogin'));
const SavedProperties = lazy(() => import('../modules/Public/Marketplace/SavedProperties'));
const EnquiryHistory = lazy(() => import('../modules/Public/Marketplace/EnquiryHistory'));
const BuyerProfile = lazy(() => import('../modules/Public/Marketplace/BuyerProfile'));

export const marketplaceRoutes = (
  <>
    <Route path="/marketplace" element={<MarketplaceHome />} />
    <Route path="/marketplace/search" element={<MarketplaceSearch />} />
    <Route path="/marketplace/properties/:slug" element={<MarketplacePropertyDetail />} />
    <Route path="/marketplace/account/register" element={<BuyerRegister />} />
    <Route path="/marketplace/account/login" element={<BuyerLogin />} />
    <Route path="/marketplace/account/saved" element={<SavedProperties />} />
    <Route
      path="/marketplace/account"
      element={(
        <BuyerProtectedRoute>
          <BuyerAccountLayout />
        </BuyerProtectedRoute>
      )}
    >
      <Route path="enquiries" element={<EnquiryHistory />} />
      <Route path="profile" element={<BuyerProfile />} />
    </Route>
  </>
);
